export default {
    Currency: {
        Name: true,
    },
};
